import { Injectable } from "@angular/core";
import { ApiService } from "../../../services/api/api.service";
import { UserInfoService } from "../../../services/user-info.service";
import { SortTableService } from "../../../services/sort-table.service";
import { Observable } from "rxjs";
import { CreateContactingDto, SupportDetailDto, SupportListDto, UpdateContactingDto } from "../models/support.models";
import { FilterSearchResultDto } from "src/app/models/filter.model";

@Injectable({
  providedIn: "root",
})
export class SupportDataService {
  agentId: string | undefined;
  userId: number | undefined;

  sort: string | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res;
      },
    });
  }

  loadSupportFilter(): Observable<any> {
    const url = `/support/filter?is_for_admin=false`;
    return this.apiService.httpGet<any>(url);
  }

  loadSupportList(page: number, search: string | undefined = "", data?: any): Observable<SupportListDto> {
    const url = `/agents/${this.agentId}/support/filter?page_number=${page}&per_page=20&order=DESC&field=SUPPORT_ID&search=${search}`;
    return this.apiService.httpPost<SupportListDto>(url, data);
  }

  loadDetailSupport(id: string): Observable<SupportDetailDto> {
    const url = `/agents/${this.agentId}/support/${id}`;
    return this.apiService.httpGet<SupportDetailDto>(url);
  }

  fileDownload(id: string): Observable<Blob> {
    const url = `/agents/${this.agentId}/support/files/${id}/download`;
    return this.apiService.httpGetBlob(url);
  }

  createContacting(data: CreateContactingDto): Observable<void> {
    const url = `/agents/${this.agentId}/support`;
    return this.apiService.httpPost<void>(url, data);
  }

  updateContacting(data: UpdateContactingDto, id: string) {
    const url = `/agents/${this.agentId}/support/${id}`;
    return this.apiService.httpPut<void>(url, data);
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/support/filter/list?page_number=0&per_page=10`;
    return this.apiService.httpPost<FilterSearchResultDto>(url, data);
  }
}
